/****************************************************************************************************
* hohe -> page-home > hero
****************************************************************************************************/

import { setCircularAttr, tlControl } from "./utils";


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// let hoheIsSnippet = false;

// if(hoheIsSnippet && typeof hoheIsRevert !== 'undefined') {
//   hoheIntroInit(gsapRef);
//   hoheElsHeadLineClear(gsapRef);
//   hoheElsOthersClear(gsapRef);
//   hoheScrollClear(gsapRef);
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Variables
let hoheSel = '.sector.hero ';
let logoPathLen = [2936, 1505] ;
let headBulbClr;
let headLineClr;
let headLineSel = '.sector.hero .head-line';
const headLineLen = [2790, 2919, 2448, 2523, 2746, 2994, 3027, 2523, 2189, 2306, 2611, 2562, 2449, 3085, 2152, 2651, 2628, 2954, 3098, 2507, 2270, 2355, 3152];
let headLineBStrokeW = 13;
// const headLineLen = [0.6974427103996277, 0.7296034097671509, 0.6118000745773315, 0.6306794285774231, 0.6864427328109741, 0.7483053207397461, 0.7566035985946655, 0.6305403709411621, 0.5471562147140503, 0.5763346552848816, 0.6525706648826599, 0.6403069496154785, 0.612231433391571, 0.7711412310600281, 0.5377800464630127, 0.6627158522605896, 0.6568875312805176, 0.7382652163505554, 0.7743833065032959, 0.6266829967498779, 0.5673574209213257, 0.5885675549507141, 0.7877807021141052];
// let headLineBStrokeW = 0.003;
let headShape = '.sector.hero .head-shape';
let headShapeStopClr = ['#01122b', '#015eea'];
let heroCopySel = '.sector.hero .hero-copy';
let heroCopyText = ["MAKE YOUR", "IDEA", "COME TO LIFE"];
let heroCopy2 = ['IDEA', 'IDEADREAM', 'DREAM', 'DREAMVISION', 'VISION', 'VISIONIDEA'];


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Intro Animation
let hoheIntroTl; // eslint-disable-line no-unused-vars

const hoheIntroInit = (gsapRef, splitTextRef, onIntroInitDone = () => {} ) => {
  if(typeof hoheIntroTl !=='undefined') hoheIntroTl.revert();

  document.querySelector('.part.header .sector').classList.remove('hohe-intro-done');
  gsapRef.set('.part.header .logo-mask' , {strokeDashoffset: (i) => logoPathLen[i]});
  gsapRef.set('.part.header .logo-path-a', {opacity: 0});
  gsapRef.set('.part.header .name-menu__name', {opacity: 0, yPercent: -70});
  gsapRef.set('.part.header .menu-bar', {opacity: 0, yPercent: -400});

  document.querySelector(hoheSel).classList.remove('hohe-intro-done');
  gsapRef.set('.head-particles-wrapper', {scale: 1});
  gsapRef.set('.head-particle', {opacity: 0});

  headBulbClr = getComputedStyle(document.querySelector(hoheSel)).getPropertyValue('--head-bulb-clr');
  headLineClr = getComputedStyle(document.querySelector(hoheSel)).getPropertyValue('--head-line-clr');
  gsapRef.set(headLineSel, {clearProps: 'all'});
  // gsapRef.set(headLineSel, {stroke: (i)=> (i%2 == 0)? headLineClr: headBulbClr, strokeDasharray: (i) => `${headLineLen[Math.floor(i/2)]} ${headLineLen[Math.floor(i/2)]}`, strokeDashoffset: (i) => headLineLen[Math.floor(i/2)]});
  gsapRef.set(headLineSel+'-a', {stroke: headBulbClr, strokeDasharray: (i) => `0 ${headLineLen[i]} 0`, strokeDashoffset: 0});
  gsapRef.set(headLineSel+'-b', {strokeWidth: headLineBStrokeW*0.1, stroke: headLineClr, strokeDasharray: (i) => `${headLineLen[i]}`, strokeDashoffset: (i) => headLineLen[i]*-1});

  gsapRef.set(headShape, {transformOrigin: '50% 50%'});
  gsapRef.set(headShape+'.fill1', {rotation: 30, scale: 0.6, zIndex: 1});
  gsapRef.set(headShape+'.stroke1', {width: '102%', left: '-1.1%', top: '-1.2%', scale: 0.65});
  gsapRef.set(headShape+'.stroke2', {width: '104%', left: '-1.9%', top: '-1.4%', scale: 0.65});
  gsapRef.set(headShape+" .head-el", {opacity: 0});
  gsapRef.set(headShape+'.fill1 .step2-blob4', {opacity: 1, morphSVG: {shape: '#head-step2-blob4'}});
  gsapRef.set(headShape+'.stroke1 .step2-blob4', {opacity: 0.7, stroke: '#f9450f00', fillOpacity: 1, morphSVG: {shape: '#head-step2-blob4'}});
  gsapRef.set(headShape+'.stroke2 .step2-blob4', {opacity: 0.7, stroke: '#f9940f00', fillOpacity: 0.8, morphSVG: {shape: '#head-step2-blob4'}});

  gsapRef.set(heroCopySel, {opacity: 0});
  gsapRef.set(heroCopySel+' .copy', {innerHTML: ''});

  onIntroInitDone();
}

const hoheIntroMake = (gsapRef, scrollTriggerRef, smootherRef, onIntroMakeDone = () => {}) => {
  let headStrokeClr1 = getComputedStyle(document.querySelector(hoheSel)).getPropertyValue('--head-shape-stroke1-clr');
  let headStrokeClr2 = getComputedStyle(document.querySelector(hoheSel)).getPropertyValue('--head-shape-stroke2-clr');
  
  hoheIntroTl = gsapRef.timeline({
    defaults: {
      ease: 'none'
    },
    // paused: true, // 20250725 jess while testing change (page transition)
    onStart: () => {
      smootherRef.paused(true);
    },
    onComplete: () => {
      hoheIntroDoneHeader(gsapRef);
      hoheIntroDoneOthers(gsapRef);
      hoheElsOthersMake(gsapRef);
      tlControl(hoheElsOthersTl, 'play');
      
      hoheScrollMake(gsapRef, scrollTriggerRef);
      
      smootherRef.paused(false);

      onIntroMakeDone();
    }
  })
  .addLabel('t0')
  
  .to('.head-shape.fill1, .head-shape.stroke', {duration: 1.099*1.5, rotation: 20, scale: 0.6, ease: 'none'})
  .to('.head-shape.fill1, .head-shape.stroke', {duration: 1.099*1, rotation: 10, scale: 0.65, ease: 'none'})
  .to('.head-shape.fill1, .head-shape.stroke', {duration: 1.099*1, rotation: 0, scale: 0.6, ease: 'none'})

  .add(
    gsapRef.timeline()
      .to('.head-shape.fill1 .step2-blob4', {duration: 1.099*1.5, ease: 'none', morphSVG: {shape: '#head-step2-blob3', type: 'rotational'}})
      .to('.head-shape.fill1 .step2-blob4', {duration: 1.099*1, ease: 'none', morphSVG: {shape: '#head-step2-blob2', type: 'rotational'}})
      .to('.head-shape.fill1 .step2-blob4', {duration: 1.099*1, ease: 'power1.in', morphSVG: {shape: '#head-step2-blob1', type: 'rotational'}})
      .to('.head-shape.fill1 .step2-blob4', {duration: 1.099*0.7, ease: 'power1.inOut', morphSVG: {shape: '#head-step1', type: 'rotational', shapeIndex: 4, origin: "54% 53%, 58% 41%"}})
      .to('.head-shape.fill1 .step2-blob4', {duration: 1.099*0.3, ease: 'none', morphSVG: {shape: '#head', type: 'rotational'}})
    , 't0'
  )

  .add(
    gsapRef.timeline()
      .to('.head-shape.stroke1 .step2-blob4', {duration:(1.099*3.5/3)+0.05, ease: 'none', repeat: 2, yoyo: true, morphSVG: {shape: '#head-step2-blob3', type: 'rotational'}})
      .to('.head-shape.stroke1 .step2-blob4', {duration: 1.099*0.7, ease: 'power1.inOut', morphSVG: {shape: '#head-step1', type: 'rotational', shapeIndex: 4, origin: "54% 53%, 58% 41%"}})
      .to('.head-shape.stroke1 .step2-blob4', {duration: 1.099*0.3, ease: 'none', morphSVG: {shape: '#head', type: 'rotational'}})
    , 't0'
  )

  .add(
    gsapRef.timeline()
      .to('.head-shape.stroke2 .step2-blob4', {duration: (1.099*3.5/2)+0.1, ease: 'none', repeat: 1, yoyo: true, morphSVG: {shape: '#head-step2-blob3', type: 'rotational'}}, 't0')
      .to('.head-shape.stroke2 .step2-blob4', {duration: 1.099*0.7, ease: 'power1.inOut', morphSVG: {shape: '#head-step1', type: 'rotational', shapeIndex: 4, origin: "54% 53%, 58% 41%"}})
      .to('.head-shape.stroke2 .step2-blob4', {duration: 1.099*0.3, ease: 'none', morphSVG: {shape: '#head', type: 'rotational'}})
    , 't0'
  )  

  .addLabel('t1', '-=1')

  .to('.head-shape.fill1', {duration: 1, scale: 1, ease: 'power1.inOut'}, 't1')
  .to('.head-shape.stroke1', {duration: 1.1, width: '104%', left: '-2.2%', top: '-2.5%', scale: 1, ease: 'power1.inOut'}, 't1')
  .to('.head-shape.stroke2', {duration: 1.2, width: '106%', left: '-2.7%', top: '-3.2%', scale: 1, ease: 'power1.inOut'}, 't1')
  .to('.head-shape.stroke1 .step2-blob4', {duration: 1, opacity: 1, fillOpacity: 0, ease: 'none'}, 't1+=1')
  .to('.head-shape.stroke2 .step2-blob4', {duration: 0.8, opacity: 1, fillOpacity: 0, ease: 'none'}, 't1+=1')
  .set('.head-shape.fill1', {zIndex: 'unset'})

  .addLabel('t2')

  .to('.head-shape.fill2 .head-el, .head-shape.fill3 .head-el', {duration: 1, opacity: 1, ease: 'power3.in', stagger: 0.2}, 't2-=1.2')
  .to('.head-shape.stroke1 .step2-blob4', {duration: 0.5, stroke: headStrokeClr1, ease: 'power1.in'}, 't2-=0.1')
  .to('.head-shape.stroke2 .step2-blob4', {duration: 0.5, stroke: headStrokeClr2, ease: 'power1.in'}, 't2+=0.1')
  .to('.head-particle', {duration: (i)=>0.75+Math.random()/2, delay: i=>Math.random(), opacity: 1, ease: 'power2.in' }, 't2-=0.75' )
  
  .addLabel('t3', 0.7999 * 0.5)

  .to(headLineSel+'-b', {duration: 1, strokeDashoffset: 0, stagger: () => 0.2 + Math.random()/2, strokeWidth: headLineBStrokeW, ease: 'power2.in'}, `t3`)
  .to(headLineSel+'-a', {duration: 1, strokeDasharray: '0 105', strokeDashoffset: (i)=>headLineLen[i]*-1, stagger: () => 0.2 + Math.random()/2, ease: 'power1.out',
    onComplete: () => {
      hoheIntroDoneHeadLine(gsapRef);
      hoheElsHeadLineMake(gsapRef);
      tlControl(hoheElsHeadLineTl, 'play');
    }}, `t3+=1.25`)
  ///// .call(() => {
  /////   hoheElsHeadLineMake(gsapRef);
  /////   tlControl(hoheElsHeadLineTl, 'play');
  ///// })

  .addLabel('t4', '-=1.5')

  .add(
    gsapRef.timeline()
      .to(heroCopySel, {duration: 0.01, opacity: 1})
      .to(heroCopySel+' .copy1', {duration: 0.9*1.5, scrambleText: {text: heroCopyText[0]}})
      .to(heroCopySel+' .copy2', {duration: 0.4*1.5, scrambleText: {text: heroCopyText[1]}}, '-=0.5')
      .to(heroCopySel+' .copy3', {duration: 1.2*1.5, scrambleText: {text: heroCopyText[2]}}, '+-0.5')
  , 't4')

  .addLabel('t5', '-=2.5')

  .add(
    gsapRef.timeline()
      .to('.logo-mask' , {duration: 0.7, strokeDashoffset: 0, stagger: 0.3, ease: 'none'})
      .to('.logo-path-a', {duration: 0.1, opacity: 1})
      .to('.name-menu__name', {duration: 0.5, opacity: 1, yPercent: 0, ease: 'power1.out',}, 0.3)
      .to('.menu-bar', {duration: 0.3, opacity: 1, yPercent: 0, ease: 'power1.out', stagger: -0.2,}, 0.3)
  , 't5');
}


// if(hoheIsSnippet) {
  // hoheIntroInit(gsapRef);
  // hoheIntroMake(gsapRef, scrollTrigger, smoother, () => {});
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Intro Done: After intro animation is done & When home is mounted again after the the App loaded
const hoheIntroDoneAll = (gsapRef) => {
  hoheIntroDoneHeader (gsapRef);
  hoheIntroDoneHeadLine (gsapRef);
  hoheIntroDoneOthers (gsapRef);
}

const hoheIntroDoneHeader = (gsapRef) => {
  document.querySelector('.part.header .sector').classList.add('hohe-intro-done');
  gsapRef.set('.part.header .logo-mask' , {clearProps: 'strokeDashoffset'});
  gsapRef.set('.part.header .logo-path-a', {clearProps: 'opacity'});
  gsapRef.set('.part.header .name-menu__name', {clearProps: 'opacity,yPercent'});
  gsapRef.set('.part.header .menu-bar', {clearProps: 'opacity,yPercent'});
}

const hoheIntroDoneHeadLine = (gsapRef) => {
  gsapRef.set(headLineSel+'-a', {clearProps: 'stroke,strokeDasharray,strokeDashoffset'});
  gsapRef.set(headLineSel+'-b', {clearProps: 'strokeWidth,stroke,strokeDasharray,strokeDashoffset'});
}

const hoheIntroDoneOthers = (gsapRef) => {
  document.querySelector(hoheSel).classList.add('hohe-intro-done');
  gsapRef.set('.head-particle', {clearProps:'opacity'});
  gsapRef.set(headShape, {clearProps:'opacity,rotation,scale'});
  gsapRef.set(headShape+ '.fill1', {clearProps: 'zIndex'});
  gsapRef.set(headShape+ '.stroke', {clearProps: 'width,left,top'});
  gsapRef.set(headShape+" .head-el", {clearProps:'opacity'});
  gsapRef.set(headShape+'.fill1 .step2-blob4', {morphSVG: {shape: '#head', type: 'rotational'}});
  gsapRef.set(headShape+'.stroke .step2-blob4', {clearProps: 'fillOpacity,stroke', morphSVG: {shape: '#head', type: 'rotational'}});
  gsapRef.set(heroCopySel, {clearProps: 'opacity'});
  gsapRef.set(heroCopySel+' .copy', {innerHTML: (i) => heroCopyText[i]});
}

// if(hoheIsSnippet) {
  // hoheIntroDoneAll(gsapRef);
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Elements Animation

let hoheElsHeadLineTl;

const hoheElsHeadLineMake = (gsapRef) => {
  ////////// Head Lines
  let linesDur = 10;
  const getIFloor = (i) => Math.floor((i/2));
  const getRandomSign = (i) =>  {
    if(i === 'undefined') return ((Math.random() < 0.5) ? 1: -1);
    else return (getIFloor(i) % 2 === 0) ? 1 : -1;
  };

  let linesTl1 = gsapRef.timeline({repeat: -1, paused: true, delay: 0})
    .to(headLineSel, {duration: linesDur*1, ease: 'none',
      scale: 1.1, rotation: (i) => getIFloor(i)%3*getRandomSign(i), x: (i) => (getIFloor(i)%5+10)*getRandomSign(i), y: (i) => (getIFloor(i)%5+10)*getRandomSign(i) }, 0)
    .to(headLineSel, {duration: linesDur*1, ease: 'none', scale: 1, rotation: 0, x: 0 , y: 0})
  
  let linesTl2 = [];
  for(let i = 0; i < headLineLen.length; i++) {
    let tl = gsapRef.timeline({delay: (i%5 ===0 ? 0 : Math.random() * 1.5), repeat: -1, paused: true})
    ///// .to(hoheSel+` .head-line-b.no${i+1}`, {duration: linesDur * 4, ease: 'none', strokeDashoffset: headLineLen[i] * -8})
    ///// .set(hoheSel+` .head-line-b.no${i+1}`, {strokeDashoffset: 0})
    .to(headLineSel+`-a.no${i+1}`, {duration: linesDur * 5 + (Math.random() * 100), ease: 'none', strokeDashoffset: headLineLen[i] * -3}, 0)
    .set(headLineSel+`-a.no${i+1}`, {strokeDashoffset: headLineLen[i] * -1})
  
    linesTl2.push(tl);
  }
  
  hoheElsHeadLineTl = [linesTl1, ...linesTl2];
}

const hoheElsHeadLineClear = (gsapRef) =>{
  if(typeof hoheElsHeadLineTl !=='undefined') {
    tlControl(hoheElsHeadLineTl, 'pause');
    tlControl(hoheElsHeadLineTl, 'remove');
  }
  gsapRef.set(headLineSel, {clearProps: 'all'});
}

let hoheElsOthersTl;

const hoheElsOthersMake = (gsapRef) => {
  ////////// Head Particles
  document.querySelector('.head-particles').classList.add('head-particles-animation-on');
  
  ////////// Head Shape
  let shapeDur = 6;
  let shape1Tl = gsapRef.timeline({repeat: -1, paused: true, delay: 0})
    .to('.head-shape.fill .head-wrap-c', {duration: shapeDur, motionPath: { path: () =>setCircularAttr(0, 0, 7, 'from', false), align: 'self' }, ease: 'none'}, 0)
    .to('.head-shape.fill .head-wrap-b', {duration: shapeDur*1, scale: 1.1, rotationX: 10, rotationY: 10, rotation: '+=4deg', ease: 'power1.inOut'}, 0)
    .to('.head-shape.fill .head-wrap-b', {duration: shapeDur*1, scale: 1, rotationX: 0, rotationY: 0, rotation: '-=4deg', ease: 'power1.inOut'}, shapeDur*1)
  let shape2Tl = gsapRef.timeline({repeat: -1, paused: true, delay: shapeDur*0})
    .to('.head-shape.stroke1 .head-wrap-c', {duration: shapeDur*1.3, motionPath: { path: () =>setCircularAttr(0, 0, 3, 'from', false), align: 'self'}, ease: 'none' }, 0)
    .to('.head-shape.stroke1 .head-wrap-b', {duration: shapeDur*1.3, scale: 0.95, rotationX: -10, rotationY: -10, rotation: '-=6deg', opacity: 0.5, ease: 'power1.inOut'}, 0)
    .to('.head-shape.stroke1 .head-wrap-b', {duration: shapeDur*1.3, scale: 1, rotationX: 0, rotationY: 0, rotation: '+=6deg', opacity: 1, ease: 'power1.inOut'}, shapeDur*1.25)
  let shape3Tl = gsapRef.timeline({repeat: -1, paused: true, delay: shapeDur*0})
    .to('.head-shape.stroke2 .head-wrap-c', {duration: shapeDur*1.6, motionPath: { path: () =>setCircularAttr(0, 0, 5, 'from', false), align: 'self'}, ease: 'none' }, 0)
    .to('.head-shape.stroke2 .head-wrap-b', {duration: shapeDur*1.6, scale: 1, rotationX: 10, rotationY: 10, rotation: '+=6deg', opacity: 0.5, ease: 'power1.inOut'}, 0)
    .to('.head-shape.stroke2 .head-wrap-b', {duration: shapeDur*1.6, scale: 1, rotationX: 0, rotationY: 0, rotation: '-=6deg', opacity: 1, ease: 'power1.inOut'}, shapeDur*1.5)

  ////////// Hero Copy2
  let copy2Dur = 2;
  gsapRef.set('.hero-copy-el.copy2', {innerHTML: heroCopy2[0]});
  let copy2Tl = gsapRef.timeline({repeat:-1, paused: true, delay: copy2Dur*0.5})
    .to('.hero-copy-el.copy2', {delay: copy2Dur*0.5, duration: copy2Dur, scrambleText: {text: heroCopy2[2], chars: heroCopy2[1]}})
    .to('.hero-copy-el.copy2', {delay: copy2Dur*0.5, duration: copy2Dur, scrambleText: {text: heroCopy2[4], chars: heroCopy2[3]}})
    .to('.hero-copy-el.copy2', {delay: copy2Dur*0.5, duration: copy2Dur, scrambleText: {text: heroCopy2[0], chars: heroCopy2[5]}})

  hoheElsOthersTl = [shape1Tl, shape2Tl, shape3Tl, copy2Tl];
}

const hoheElsOthersClear = (gsapRef) => {
  document.querySelector('.head-particles').classList.remove('head-particles-animation-on');

  if(typeof hoheElsOthersTl !=='undefined') {
    tlControl(hoheElsOthersTl, 'pause');
    tlControl(hoheElsOthersTl, 'remove');
  }
  gsapRef.set('.head-shape .head-wrap-b, .head-shape .head-wrap-c', {clearProps: 'all'});
  gsapRef.set('.head-shape .head-wrap-b, .head-shape .head-wrap-c', {transformOrigin: '50% 50%'});

  gsapRef.set('.hero-copy-el.copy2', {innerHTML: heroCopy2[0]});
}

const hoheElsControl = (opt='play') => {
  tlControl(hoheElsHeadLineTl, opt);
  tlControl(hoheElsOthersTl, opt);
  document.querySelectorAll('.head-particle').forEach(el => el.style.animationPlayState = (opt==='play')? 'running' : 'paused');
}


// if(hoheIsSnippet) {
  // hoheElsHeadLineMake(gsapRef);
  // hoheElsOthersMake(gsapRef);
  // hoheElsControl('play');
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Scroll Animation
let hoheScrollTl;  // eslint-disable-line no-unused-vars
// let hoheElsTlToggleSt;  // eslint-disable-line no-unused-vars

const hoheScrollMake = (gsapRef, scrollTriggerRef) => {
  let hoheScrollDur = 1;

  ////////////////////////////// container-in, elements on scroll

  hoheScrollTl = gsapRef.timeline({
    scrollTrigger: {
      id: 'hoheScrollTl',
      trigger: hoheSel,
      toggleActions: 'restart complete reverse reset',
      start: 'bottom bottom',
      // end: 'bottom top',
      end: '+=100%',
      scrub: true,
      toggleClass: 'scroll-active',
      // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
      // onEnter: (self) =>{},
      onLeave: (self) => {
        hoheElsControl('pause');
      },
      onEnterBack: (self) => {
        hoheElsControl('play');
      },
      // onLeaveBack: (self) => {},
      // onUpdate: (self) => console.log(`${self.vars.id}: onUpdate:`, self.progress.toFixed(3)),
      // onToggle: (self) => console.log(`${self.vars.id}: onToggle:`, self.isActive)
    }
  })
  .addLabel('t0')
  .to('.sector.hero .container-in', {duration: hoheScrollDur, y: '100%', ease: 'none'}, 't0')
  
  .to('.head-particles-wrapper', { duration: hoheScrollDur*0.9, x:'-2%', y: '2%', scale: 1.1, ease: 'none'}, 't0')

  .to('.svg-head.svg-head-lines', { duration: hoheScrollDur*0.9, scale: 1.15, ease: 'none'}, 't0')

  .to('.head-shape.fill .head-wrap-a', { duration: hoheScrollDur*0.85, scale: 0.7, rotation: '5eg', ease: 'power1.in'}, 't0')
  .to('.head-shape.stroke1 .head-wrap-a', { duration: hoheScrollDur*0.85, scale: 0.7, rotation: '-7deg', ease: 'power1.in'}, 't0')
  .to('.head-shape.stroke2 .head-wrap-a', { duration: hoheScrollDur*0.85, scale: 0.7, rotation: '7deg', ease: 'power1.in'}, 't0')
    
  .add(
    gsapRef.timeline()
      .to('.head-shape.fill1 .step2-blob4, .head-shape.stroke .step2-blob4', {duration: hoheScrollDur*0.15, ease: 'power1.in', morphSVG: {shape: '#head-step1', type: 'rotational'}})
      .to('.head-shape.fill1 .step2-blob4, .head-shape.stroke .step2-blob4', {duration: hoheScrollDur*0.2, ease: 'none', morphSVG: {shape: '#head-step2-blob1', type: 'rotational', shapeIndex: 4, origin: "54% 53%, 58% 41%"}})
      .to('.head-shape.fill1 .step2-blob4, .head-shape.stroke .step2-blob4', {duration: hoheScrollDur*0.15, ease: 'power1.out', morphSVG: {shape: '#head-step2-blob4', type: 'rotational', shapeIndex: 4, origin: "54% 53%, 58% 41%"}})
      .to('.head-shape.fill:not(.fill1) .head-wrap-a, .head-shape.stroke .head-wrap-a', {duration: hoheScrollDur*0.2, opacity: 0, ease: 'power4.out'}, 0),
    't0+='+(hoheScrollDur*0.5)
  )

  .to('#gr-ho-he-head stop', { duration: hoheScrollDur*0.15, attr: {"stop-color": (i) => headShapeStopClr[i]}, ease: 'power2.in'}, 't0+='+(hoheScrollDur*0.5))
    
  .addLabel('t1', hoheScrollDur*0.85)
  .to('.head-shape.fill1 .head-wrap-a, .head-shape.stroke .head-wrap-a', { duration: hoheScrollDur*0.15, scale: (i)=> 10+i*2, rotation: '0eg', ease: 'power1.in'}, 't1')
  .to('.hero-copy-wrap-a', { duration: hoheScrollDur*0.05, opacity: 0, ease: 'power4.out'}, 't1')

  .add(()=> {}, hoheScrollDur)
  ;

  // ////////////////////////////// elements animation play / pause, must be same start/end as hero-web show
  // hoheElsTlToggleSt = scrollTriggerRef.create({
  //   id: 'hoheElsTlToggleSt',
  //   trigger: '.sector.hero-web',
  //   start: 'top 30%',
  //   end: '+=0',
  //   // markers: {startColor: "yellow", endColor: "yellow", fontSize: "10px", fontWeight: "bold", indent: 200},
  //   onEnter: () => tlControl(hoheElsTl, 'pause'),
  //   onEnterBack: () => tlControl(hoheElsTl, 'play'),
  //   toggleActions: 'restart none reverse none'
  // });
  
}

const hoheScrollClear = (gsapRef, scrollTriggerRef) => {
  if(typeof hoheScrollTl !=='undefined') hoheScrollTl.revert();

  gsapRef.set('.sector.hero .container-in', {clearProps: 'y'});
  gsapRef.set('.head-particles-wrapper', {clearProps: 'scale'});
  gsapRef.set('.svg-head.svg-head-lines', {clearProps: 'all'});
  gsapRef.set('.head-shape.fill .head-wrap-a, .head-shape.stroke .head-wrap-a, #gr-ho-he-head stop', {clearProps: 'all'});
  gsapRef.set('.head-shape.fill1 .step2-blob4, .head-shape.stroke .step2-blob4', {morphSVG: {shape: '#head', type: 'rotational'}});
  gsapRef.set('.hero-copy-wrap-a', {clearProps: 'all'});
  
  // if(typeof hoheElsTlToggleSt !=='undefined') hoheElsTlToggleSt.revert();
}

// if(hoheIsSnippet) {
  // hoheScrollMake(gsapRef, scrollTrigger);
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
///  Resizing
const hoheResizeStart = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home hero] Resize: START");
}

const hoheResizeDone = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef, isHomeIntroPlayed, onIntroMakeDone) => {
  console.log("[home hero] Resize: END");

  if(!isHomeIntroPlayed) {
    ///////// Before Intro
    hoheElsHeadLineClear(gsapRef); // Hero
    hoheElsOthersClear(gsapRef); // Hero
    hoheScrollClear(gsapRef); // Hero

    hoheIntroInit(gsapRef);
    hoheIntroMake(gsapRef, scrollTriggerRef, smootherRef, onIntroMakeDone);
  } else {
    ////////// After Intro
    hoheIntroDoneAll(gsapRef); // Hero
    hoheElsHeadLineClear(gsapRef); // Hero
    hoheElsOthersClear(gsapRef); // Hero
    hoheScrollClear(gsapRef); // Hero
    hoheElsHeadLineMake(gsapRef); // Hero
    hoheElsOthersMake(gsapRef); // Hero
    hoheScrollMake(gsapRef); // Hero
    hoheElsControl('play'); // Hero
  }
}

////////// Code for snippet
// let hoheResizing = false;
// const hoheResizeHandle = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
//   if(!hoheResizing) {
//     hoheResizing = true;
//     smootherRef.paused(true);
//     scrollTriggerRef.disable();

//     hoheResizeStart(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }

//   waitForFinalEvent(function() {
//     hoheResizing = false;
//     smootherRef.paused(false);
//     scrollTriggerRef.enable();
//     scrollTriggerRef.refresh(); // jess: After resizing done, refresh the ScrollTrigger

//     hoheResizeDone(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }, 1000, 'hoheResize');
// }
// if(hoheIsSnippet) {
//   if(typeof hoheIsRevert !== 'undefined') window.removeEventListener('resize', hoheResizeHandleRef);
//   window.hoheResizeHandleRef = hoheResizeHandle;
//   window.addEventListener('resize', hoheResizeHandleRef);
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
///  Control Key

// Play / Pause Elements animation
const hoheControlKey = (key) => {
  if(!document.querySelector(".page-home") || !hoheElsHeadLineTl) return;

  let opt = hoheElsHeadLineTl[0].paused() ? 'play' : 'pause'
  hoheElsControl(opt);
  console.log(`[home: hero] [key: ${key} pressed] Elements animation: ${opt}`);
};

// ////////// Code for snippet
// const hoheControlKeyHandler = (e) => { if(e.key === '1') hoheControlKey(e.key); }
// if(hoheIsSnippet) {
//   if(typeof hoheIsRevert !== 'undefined')  window.removeEventListener('keydown', hoheControlKeyHandlerRef);
//   window.hoheControlKeyHandlerRef = hoheControlKeyHandler;
//   window.addEventListener('keydown', hoheControlKeyHandlerRef);
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// if(hoheIsSnippet) var hoheIsRevert = true;


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Export
export {
  hoheIntroInit,
  hoheIntroMake,
  hoheIntroDoneAll,
  hoheElsHeadLineMake,
  hoheElsHeadLineClear,
  hoheElsOthersMake,
  hoheElsOthersClear,
  hoheElsControl,
  hoheScrollMake,
  hoheScrollClear,
  hoheResizeStart,
  hoheResizeDone,
  hoheControlKey
}